import { useMutation, useQueryClient } from '@tanstack/react-query';

import { Entity } from '../../../../../types/utility';
import { handleSuccess } from '../../../../../utils/admin';
import { patchDocument } from '../../../../documents/requests/patchDocument';
import { useRequestConstructor } from '../../../../hooks/useRequestConstructor';
import { APPLICATION_BASE_PATH } from '../../constants/applicationBasePath';

export const useUpdateApplicationDoc = (
  definitionName: string,
  applicationUuid: string,
) => {
  const queryClient = useQueryClient();
  const { constructPatch } = useRequestConstructor();

  const { mutateAsync: updateDocument, ...rest } = useMutation({
    mutationFn: ({ documentId, data }: { documentId: string; data: Entity }) =>
      patchDocument(
        constructPatch,
        documentId,
        { definition: definitionName },
        data,
      ),
    onSuccess: () => {
      handleSuccess('Updated');
      queryClient.invalidateQueries({
        queryKey: [APPLICATION_BASE_PATH, applicationUuid, 'docs'],
      });
      queryClient.invalidateQueries({
        queryKey: [
          APPLICATION_BASE_PATH,
          applicationUuid,
          'docs-uncategorized',
        ],
      });
    },
  });

  return { updateDocument, ...rest };
};
